import React from 'react';
import { Route, Routes } from "react-router-dom";
import { MainLayout, LoginLayout } from "../layout";
import { Login } from "../pages/Auth";
import { Home } from "../pages/dashboard";
import { PriceManag } from "../pages/priceManagment";
import { Admin, AdminProfile, AddAdmin } from "../pages/userManagment/admin";
import { Member, MemberProfile } from "../pages/userManagment/member";
import { Chat } from "../pages/helpCenter/chat";
import { Faq } from "../pages/helpCenter/faq";
import { HelpCenter } from "../pages/helpCenter";
import { Setting } from "../pages/settings";
import { StockManag } from "../pages/stockManagment";
import { NotFound } from '../pages/Other';
import { UserProfile } from "../pages/Profile";
import PrivateRoute from './PrivateRoute';


const AppRoutes = () => {
  
  
  return (
    <React.Fragment>
    <Routes>
        <Route path="/" element={<LoginLayout />}>
           <Route path="/" exact element={<Login />} />
        </Route>
           <Route path='*' element={<NotFound />} />
       
          
        
        <Route path={"/dashboard"} element={ <MainLayout />}>
          <Route element={<PrivateRoute />} >
          <Route index  element={<Home /> } />
          <Route path='profile' element={ <UserProfile /> } />
          <Route path='user-management/admin' element={ <Admin />} />
          <Route path='user-management/admin/:id' element={<AdminProfile /> } />
          <Route path='user-management/admin/add-new-admin' element={<AddAdmin /> } />
          <Route path='user-management/member' element={<Member /> } />
          <Route path='user-management/member/:username' element={<MemberProfile /> } />
          <Route path='price-management' element={<PriceManag />} />
          <Route path='help-center' element={<HelpCenter /> } />
          <Route path='help-center/chat' element={<Chat /> } />
          <Route path='help-center/faq' element={<Faq />} />
          <Route path='stock-management' element={<StockManag />} />
          <Route path='settings' element={<Setting />} />
          </Route>
        </Route>
      
    </Routes>
</React.Fragment>
  )
  }
  
export default AppRoutes;